var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('GenericAutocomplete',{attrs:{"label":"name","placeholder":"Buscar tercero...","search-records":_vm.findEntity},model:{value:(_vm.entity),callback:function ($$v) {_vm.entity=$$v},expression:"entity"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }